/** Dark blue from the 10 Teams wordmark (`smolNavLight.svg` cls-4). */
export const AI_LEAGUE_NAME_COLOR = '#2d1eaa';

export function formatAiResponseTime(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}m ${seconds}s`;
}
